import Question from './Question.component';

export default Question;
